export const localstorageNameSpace = {
  SHOW_FILTER: "SHOW_FILTER",
};

// Ensure all creatable options scope are saved here to avoid duplicate scopes
export const creatableOptionScopes = {
  fleet_route_addresses: "fleet_route_addresses",
  fleet_expense_categories: "fleet_expense_categories",
  fleet_document_categories: "fleet_document_categories",
  scheme_document_categories: "scheme_document_categories",
};

export const GENERAL_SETTINGS_TAB = {
  GENERAL: "GENERAL",
  ACCOUNTS: "ACCOUNTS",
};

export const ACCOUNT_MAPPING_ENTITY_TYPES = {
  INVENTORY: "INVENTORY",
  SYSTEM_WIDE: "SYSTEM_WIDE",
  VENDOR: "VENDOR",
  CUSTOMER: "CUSTOMER",
  EMPLOYEE: "EMPLOYEE",
  PRODUCTION: "PRODUCTION",
};

export const SYSTEM_WIDE_ACCOUNT_MAPPING = {
  INVENTORY_IN_VENDOR_POSSESSION: {
    label: "Inventory in Vendor Possession",
    actionType: "INVENTORY_IN_VENDOR_POSSESSION",
  },
  ACCOUNTS_PAYABLE: {
    label: "Accounts Payable",
    actionType: "ACCOUNTS_PAYABLE",
  },
  ACCOUNTS_RECEIVABLE: {
    label: "Accounts Receivable",
    actionType: "ACCOUNTS_RECEIVABLE",
  },
  DAMAGES: { label: "Damages (Company)", actionType: "DAMAGES" },
  DAMAGES_VENDOR: {
    label: "Damages (Vendor Claim)",
    actionType: "DAMAGES_VENDOR",
  },
  DAMAGES_DRIVER: {
    label: "Damages (Driver Claim)",
    actionType: "DAMAGES_DRIVER",
  },
};

export const ITEM_ACCOUNT_MAPPING = {
  INVENTORY: {
    label: "Inventory",
    actionType: "INVENTORY",
  },
  SALES_REVENUE: {
    label: "Sales/Income",
    actionType: "SALES_REVENUE",
  },
  CANCELLED: {
    label: "Cancelled",
    actionType: "CANCELLED",
  },
};

// Per-vendor override of SYSTEM_WIDE_ACCOUNT_MAPPING.DAMAGES_VENDOR — same
// actionType, scoped to entityType VENDOR/entityId Vendor_ID instead of
// SYSTEM_WIDE/SYSTEM. Optional: the backend falls back to the system-wide
// account when a vendor has no override configured.
export const VENDOR_ACCOUNT_MAPPING = {
  DAMAGES_VENDOR: {
    label: "Damages Claim (Override)",
    actionType: "DAMAGES_VENDOR",
  },
};

// Per-employee override of SYSTEM_WIDE_ACCOUNT_MAPPING.DAMAGES_DRIVER — same
// fallback behavior as VENDOR_ACCOUNT_MAPPING above. Covers drivers, who are
// tracked as Employees (keyed by EmployeeID) elsewhere in the ATC flow.
export const EMPLOYEE_ACCOUNT_MAPPING = {
  DAMAGES_DRIVER: {
    label: "Damages Claim (Override)",
    actionType: "DAMAGES_DRIVER",
  },
};

// Per-customer override of SYSTEM_WIDE_ACCOUNT_MAPPING.ACCOUNTS_RECEIVABLE.
export const CUSTOMER_ACCOUNT_MAPPING = {
  ACCOUNTS_RECEIVABLE: {
    label: "Accounts Receivable (Override)",
    actionType: "ACCOUNTS_RECEIVABLE",
  },
};

export const PRODUCTION_ACCOUNT_MAPPING = {
  PRODUCTION_INVENTORY: {
    label: "Item Account",
    actionType: "PRODUCTION_INVENTORY",
  },
};
